/**
 * Enum for the content type. One of these values should be returned from
 * the "getContentType" function.
 * @enum {string}
 */
export const CONTENT_TYPE = {
  AD: "ad",
  CONTENT: "ct"
};

/**
 * Enum for the ad position. One of these values should be returned from
 * the "getAdPosition" function.
 * @enum {string}
 */
export const AD_POSITION = {
  PREROLL: "a1",
  MIDROLL: "a2",
  POSTROLL: "a3",
  OVERLAY: "a4",
  SPECIAL: "a5"
};

/**
 * Enum for the video state. One of these values should be returned from
 * the "getState" function.
 * @enum {string}
 */
export const VIDEO_STATE = {
  UNPLAYED: "s1",
  PLAYED: "s2",
  STOPPED: "s3",
  COMPLETED: "s4"
};

export const AUTOPLAY_TYPE = {
  UNKNOWN: "unkn",
  MANUAL: "man",
  AUTOPLAY: "auto",
  CONTINUOUS: "cont"
};
